var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center badge-outer p-3"},[_c('div',{staticClass:"ring d-flex align-center justify-center",class:{
      ringLevel0: _vm.level == 0,
      ringLevel1: _vm.level == 1,
      ringLevel2: _vm.level == 2,
      ringBold: _vm.ringBold,
    }},[_c('img',{style:([_vm.level == 0 ? { filter: 'grayscale(100%)' } : {}]),attrs:{"src":_vm.image_path}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }